import { useState } from "react";

import { CustomersTable } from "../Tables";
import StaffModal from "./StaffModal";
import CustomerModal from "./CustomerModal";

function Customers({ doctor }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});

  // onClick event handler
  const handleEventClick = (event) => {
    setData(event);
    setOpen(!open);
  };
  // handle modal close
  const handleClose = () => {
    setOpen(!open);
    setData({});
  };
  return (
    <div className="w-full">
      {open && (
        <CustomerModal
          datas={data}
          isOpen={open}
          closeModal={() => {
            handleClose();
          }}
        />
      )}

      <div className="w-full overflow-x-scroll scrollbar-thin">
        <CustomersTable
          data={doctor}
          doctor={doctor}
          functions={{
            preview: handleEventClick,
          }}
        />
      </div>
    </div>
  );
}

export default Customers;
